import React, { Component } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './page-header.scss';
import { actionCreator } from './page-header-actions';
import Text from './page-header-text';

@styleable(css)
class PageHeader extends Component {
    static propTypes = {
        /** @todo use the props declared below and remove the eslint directive on the next line */
        /* eslint react/no-unused-prop-types: 0 */
        action: PropTypes.func,
        pageHeaderReducer: PropTypes.object
    };

    componentWillUpdate() {}

    render() {
        const { title, subTitle } = this.props.pageHeaderReducer;
        return (
            <div className={`${css['page-header']} page-header`}>
                <div className={css.title}>{Text[title]}</div>
                <div className={'sub-title'}>{Text[subTitle]}</div>
            </div>
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from PageHeaderCombinedReducers.
 */
function mapStateToProps(state) {
    return {
        pageHeaderReducer: state.pageHeaderReducer
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    /**
     * @todo ensure that 'actionCreator' below matches the name
     * of the corresponding action creator function in page-header-actions.js,
     * and add an action creator entry for each action the component uses.
     */
    return bindActionCreators({
        actionCreator
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader);



// WEBPACK FOOTER //
// ./components/page-header/page-header.js